import type { CustomerField, Workflow } from "~/types/api";
import type { TaskManagerDTO } from "~/types/api-custom";

type Props = {
  task: TaskManagerDTO;
  customerFields: CustomerField[];
  workflowById: Map<number, Workflow>;
  searchQuery: string;
};

export const matchesTaskFields = ({
  task,
  customerFields,
  workflowById,
  searchQuery,
}: Props): boolean => {
  const taskWorkflow = workflowById.get(task.workflowId);
  if (!taskWorkflow?.fields) return false;

  return customerFields.some((customerField) => {
    const matchingWorkflowField = taskWorkflow.fields!.find(
      (wf) => wf.name === customerField.name && wf.type === customerField.type
    );
    if (!matchingWorkflowField) return false;

    const value = task.taskFields?.find((tf) => tf.fieldId === matchingWorkflowField.id)?.value;

    return value ? String(value).toLowerCase().includes(searchQuery.toLowerCase()) : false;
  });
};
